<template>
  <div class="carousel">
    <agile :dots="true" :autoplay="true" :autoplaySpeed="4000" :infinite="true" :navButtons="false">
      <div class="slide"><img src="./../assets/screenshot.png" alt="screenshot" /></div>
      <div class="slide"><img src="./../assets/screenshot02.png" alt="screenshot" /></div>
      <div class="slide"><img src="./../assets/screenshot03.png" alt="screenshot" /></div>
      <div class="slide"><img src="./../assets/screenshot04.png" alt="screenshot" /></div>
      <div class="slide"><img src="./../assets/screenshot05.png" alt="screenshot" /></div>
    </agile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile';

export default {
  name: "Carousel",
  components: {
      agile: VueAgile
  }
}
</script>

<style lang="scss">
.agile__actions {
  padding-top: 1.6rem;
}
.agile__dot {
  margin: 0 10px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  list-style: none;
  padding: 0;
  white-space: nowrap;
  button {
    background-color: #eee;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: block;
    height: 10px;
    font-size: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
    -webkit-transition-duration: .3s;
    transition-duration: .3s;
    width: 10px;
    background-color: #444;
  }
}
.agile__dot--current button, .agile__dot:hover button {
  background-color: #999;
}
</style>